// Never import any server-only code here, this is also used on the client side...
import type { TranslationsMap } from './types';

// French version of the translation file
export const translations: TranslationsMap = {
  emails: {
    footer: {
      kindRegards: 'Cordialement,',
      questionsOrProblems: 'Des questions ou des problèmes?',
      contactUs: 'Contactez-nous',
    },
    transportOrder: {
      confirm: 'Confirmer',
      refuse: 'Refuser',
    },
    forgotPassword: {
      resetLink: 'Réinitialiser le mot de passe',
    },
    userInvite: {
      view: `Afficher l'invitation`,
    },
    attachments: {
      quotation: 'Offerte {{reference}}',
    },
    customerComplaintAlert: {
      order: 'Voir la commande',
    },
  },
  truckDocumentType: {
    Insurance: 'Assurance',
    Examination: 'Examen',
  },
  orderDocumentType: {
    cmr: 'CMR',
    deliveryNote: 'Bon de livraison',
    weighSlip: 'Bon de pesée',
    palletNote: 'Bon de palettes',
    annexII: 'Annexe II',
    t1Document: 'Document T1',
    annexVII: 'Annexe VII',
    saleInvoice: 'Facture',
    transportOrder: 'Ordre de transport',
    orderConfirmation: 'Confirmation de commande',
    sustainabilityReport: 'Rapport de durabilité',
    customerAttachment: 'Pièce jointe client',
    planning: 'Planning',
    other: 'Autre',
  },
  documentRejection: {
    subject: 'Document refusé pour le dossier {{orderNumber}}',
    intro: "Nous n'avons pas pu valider le document {{documentType}} reçu pour le dossier {{orderNumber}}. Raisons:",
    outro: 'Merci de renvoyer un document corrigé via votre canal habituel ou via le portail transporteur. Merci !',
    MissingSignature: 'La signature du destinataire est absente du CMR.',
    WrongCustomer: 'Le client mentionné sur le document ne correspond pas au client de ce dossier.',
    WrongOrgOnDocument: "L'expéditeur/transitaire indiqué sur le document ne correspond pas à notre organisation.",
    NoOrderReference:
      "Nous n'avons trouvé aucune référence de dossier ou de facture permettant de relier ce document à une commande.",
    WrongDocumentType: 'Le type de document ne correspond pas à ce qui est attendu pour ce dossier.',
    LowQuality:
      "La qualité du scan/de la photo est insuffisante pour valider le contenu de manière fiable. Merci d'envoyer une copie de meilleure qualité.",
  },
  trailerTypes: {
    BoxTrailer: 'Remorque fourgon',
    FlatBed: 'Plateau',
    Mega: 'Méga-remorque',
    Refrigerated: 'Remorque réfrigérée',
    RoadTrain: 'Train routier',
    Tautliner: 'Rideau coulissant',
    Joloda: 'Rideau coulissant / Joloda',
    TautlinerCoil: 'Rideau coulissant / Coil',
  },
  loadingMethods: {
    Back: 'Arrière',
    Side: 'Côté',
    Top: 'Par le toit',
  },
  documents: {
    note: {
      extraInformation: 'Informations supplémentaires',
    },
    letter: {
      letter: 'Lettre',
    },
    paymentReminder: {
      invoiceNumber: 'Numéro de facture',
      invoiceDate: 'Date de facturation',
      dueDate: "Date d'échéance",
      amount: 'Montant',
      expiredAmount: 'Montant expiré',
      currency: 'Devise',
      totalOutstanding: 'Total dû',
      salutation: 'Madame, Monsieur,',
      subject: {
        first: 'Objet : rappel de paiement — {{reference}}',
        second: 'Objet : deuxième rappel de paiement — {{reference}}',
        third: 'Objet : troisième rappel de paiement — {{reference}}',
        final: 'Objet : mise en demeure — {{reference}}',
      },
      intro: {
        first:
          'Il ressort de notre administration que les factures ci-dessous ne sont pas encore réglées. Si votre paiement a croisé ce courrier, veuillez ne pas en tenir compte.',
        second: 'Malgré notre rappel précédent, nous n’avons pas encore reçu le paiement des factures ci-dessous :',
        third: 'Malgré des rappels répétés, les factures ci-dessous restent impayées :',
        final:
          'Malgré nos précédents rappels de paiement, nous n’avons à ce jour reçu aucun paiement pour les factures ci-dessous :',
      },
      request:
        'Nous vous demandons de virer le montant dû de {{amount}} sur le compte ci-dessous dans les {{days}} jours calendrier suivant la réception de ce courrier, en mentionnant la référence :',
      acknowledgement:
        'Si vous ne payez pas et n’en indiquez pas la raison, cela sera considéré comme une reconnaissance de dette.',
      escalation: {
        first: 'Si nous ne recevons pas votre paiement dans ce délai, nous vous adresserons un nouveau rappel.',
        second: 'Si nous ne recevons pas votre paiement dans ce délai, nous serons contraints d’escalader ce dossier.',
        third: 'À défaut de paiement dans ce délai, ce dossier sera transmis à notre procédure de recouvrement.',
        final:
          'À défaut de paiement dans ce délai, nous confierons ce dossier à notre conseil sans autre avertissement, avec pour instruction d’engager une procédure judiciaire à votre encontre. Les frais seront entièrement à votre charge.',
      },
      closing: {
        first: 'Nous comptons sur vous pour régler le montant dû dans le délai demandé.',
        second: 'Nous comptons sur vous pour régler le montant dû dans le délai demandé.',
        third: 'Nous comptons sur vous pour régler le montant dû dans le délai demandé.',
        final:
          'Nous espérons que cela ne sera pas nécessaire et que vous réglerez le montant dû dans le délai demandé.',
      },
      sincerely: 'Cordialement,',
      signature: 'Comptabilité {{company}}',
      account: 'Compte {{company}}',
      accounts: 'Comptes {{company}}',
      reference: 'Communication',
      amountDue: 'Montant à payer',
      bic: 'BIC',
      heldBy: 'au nom de {{company}}',
      date: 'Date',
      ourReference: 'Notre référence',
      customerNumber: 'Numéro de client',
      yourVatNumber: 'Votre numéro de TVA',
      contact: 'Contact',
      phone: 'Téléphone',
    },
    quotation: {
      quotation: 'Offerte',
      customerNumber: 'Numéro de client',
      reference: 'Référence',
      date: "Date de l'offre",
      dueDate: "Date d'échéance",
      from: 'De',
      to: 'À',
      volume: 'Volume',
      price: 'Prix',
      generalTermsAndConditions: 'Conditions générales de vente jointes',
      questionsOrComments: "Pour toute question, veuillez nous contacter à l'adresse {{email}}",
      trailerTypes: 'Types de remorques',
    },
    transportOrder: {
      trailerTypes: 'Types de remorques',
      loadingMethod: 'Mode de chargement',
      transportOrder: 'Ordre de transport',
      date: 'Date',
      orderRef: 'Référence de la commande',
      load: 'Charger',
      unload: 'Décharger',
      reference: 'Référence',
      goods: 'Marchandises',
      description: 'Description',
      packageType: 'Type de palette',
      palletCount: 'Palettes',
      weight: 'Poids',
      LoadingMeter: 'Compteur de charge',
      freightRate: 'Tarif de fret',
      price: 'Prix',
      vat: 'TVA',
      questionsOrComments: 'Questions ou commentaires?',
      contactFileManager: `N'hésitez pas à contacter votre responsable de dossier`,
      anonymousCmr: 'UN CMR ANONYME DOIT ÊTRE CRÉÉ POUR CETTE COMMANDE.',
      phone: 'Téléphone',
      email: 'Email',
    },
    planning: {
      planning: 'Planification',
      licensePlate: 'Plaque d immatriculation',
      codeName: 'Nom de code',
    },
    kilometers: {
      full: 'Kilomètres chargés',
      empty: 'Kilomètres à vide',
      total: 'Kilomètres total',
      planningTotal: 'Total de cette planification',
    },
    orderConfirmation: {
      orderConfirmation: 'Confirmation de commande ',
      dearCustomer: 'Cher client, ',
      herebyWeConfirmYourOrder: 'Nous confirmons par la présente votre commande pour le transport suivant:',
      date: 'Date',
      ourReference: 'Notre référence',
      yourReference: 'Votre référence',
      load: 'Charger',
      unload: 'Décharger',
      reference: 'Référence',
      goods: 'Marchandises',
      description: 'Description',
      packageType: 'Type de palette',
      palletCount: 'Palettes',
      weight: 'Poids',
      LoadingMeter: 'Compteur de charge',
      freightRate: 'Tarif de fret',
      price: 'Prix',
      vat: 'TVA',
      questionsOrComments: 'Questions ou commentaires?',
      contactFileManager: `N'hésitez pas à contacter votre responsable de dossier`,
      phone: 'Téléphone',
      email: 'Email',
    },
    orderCancellation: {
      orderCancellation: 'Annulation de commande',
      dearCustomer: 'Cher client, ',
      orderCancelledText: 'Votre commande pour le transport ci-dessous a été annulée:',
      date: 'Date',
      ourReference: 'Notre référence',
      yourReference: 'Votre référence',
      load: 'Charger',
      unload: 'Décharger',
      reference: 'Référence',
      goods: 'Marchandises',
      description: 'Description',
      packageType: 'Type de palette',
      palletCount: 'Palettes',
      weight: 'Poids',
      LoadingMeter: 'Compteur de charge',
      freightRate: 'Tarif de fret',
      price: 'Prix',
      vat: 'TVA',
      questionsOrComments: 'Questions ou commentaires?',
      contactFileManager: `N'hésitez pas à contacter votre responsable de dossier`,
      phone: 'Téléphone',
      email: 'Email',
    },
    invoice: {
      invoice: 'Facture',
      customerNumber: 'Numéro de client',
      invoiceNumber: 'Numéro de facture',
      invoiceDate: 'Date de facture',
      dueDate: `Date d'échéance`,
      load: 'Chargement',
      unload: 'Déchargement',
      ourReference: 'Notre référence',
      yourReference: 'Votre référence',
      description: 'Description',
      quantity: 'Quantité',
      unitPrice: 'Prix unitaire',
      total: 'Total',
      vat: 'TVA',
      paymentInformation: 'Informations de paiement',
      amountToPay: 'Montant à payer',
      toBePaidBefore: 'À payer avant',
      beneficiary: 'Bénéficiaire',
      message: 'Message',
      generalTermsAndConditions: 'Conditions générales de vente jointes',
      questionsOrComments: `Pour toute question, veuillez contacter le service comptabilité à l'adresse {{email}}`,
    },
    sustainabilityReport: {
      sustainabilityReport: 'Rapport de durabilité',
      date: 'Date',
      ourReference: 'Notre référence',
      yourReference: 'Votre référence',
      truck: 'Truck',
      distance: 'Distance',
      weight: 'Poids',
      emissions: 'Émissions',
      questionsOrComments: 'Questions ou commentaires?',
      contactFileManager: `N'hésitez pas à contacter votre responsable de dossier`,
      phone: 'Téléphone',
      email: 'Email',
    },
    globalSustainabilityReport: {
      sustainabilityReport: 'Rapport de développement durable',
      date: 'Date',
      startDate: 'Date de début',
      endDate: 'Date de fin',
      orderCount: 'Nombre de commandes',
      truck: 'Camion',
      totals: 'Total',
      distance: 'Distance',
      weight: 'Poids',
      emissions: 'Émissions de CO2',
      averagePerOrder: 'Moyenne par commande',
      framework:
        'Pour plus de détails sur le calcul des émissions, consultez la politique de développement durable sur notre site web.',
      questionsOrComments: 'Questions ou commentaires ?',
      contactFileManager: "N'hésitez pas à contacter votre gestionnaire de dossier",
      phone: 'Tél.',
      email: 'E-mail',
    },
    rideOverview: {
      title: 'Aperçu',
      entryNumber: 'Référence de l’aperçu',
      dossier: 'Dossier',
      draftBanner: 'Brouillon — non encore approuvé',
      invoiceRequestNotice:
        'Ce document n’est pas une autofacture valable. À la réception de cet aperçu, {{customer}} attend de votre part une facture pour ces commandes.',
    },
    selfBill: {
      title: 'Autofacture',
      number: 'N°',
      draftBanner: 'Brouillon — non encore approuvé',
      supplierLabel: 'Fournisseur — transporteur · nous payons cette société',
      customerLabel: 'Client — établit cette facture au nom du fournisseur',
      vatCompanyNumber: "TVA / N° d'entreprise :",
      vatShort: 'TVA',
      carrierNumber: 'Numéro de transporteur : {{number}}',
      customerRegister: 'RPM Gand, division Courtrai',
      bankLabel: 'Paiement sur le compte bancaire du fournisseur',
      bankNotice:
        "Enregistré dans notre fichier transporteurs. S'il ne s'agit pas de votre compte, contactez immédiatement {{email}}. Les coordonnées bancaires ne sont modifiées que via notre procédure de vérification, jamais sur la base d'une demande par e-mail.",
      documentType: 'Type de document',
      invoiceNumber: 'Numéro de facture',
      invoiceDate: 'Date de facture',
      servicePeriod: 'Période de prestation',
      agreement: 'Convention',
      paymentDate: 'Date de paiement',
      natureOfServices:
        "Nature des services : {{nature}}, un trajet par ligne, effectué à la date d'expédition indiquée. Prix unitaire = montant de la ligne (quantité 1), hors TVA.",
      roadFreightTransport: 'transport routier de marchandises',
      columnNumber: 'N°',
      columnFile: 'Dossier',
      columnShipmentDate: "Date d'expédition",
      columnLoading: 'Chargement',
      columnUnloading: 'Déchargement',
      columnQuantity: 'Qté',
      columnVat: 'TVA',
      columnAmount: 'EUR',
      tripCountOne: '1 trajet sur cette facture',
      tripCountOther: '{{count}} trajets sur cette facture',
      totalServices: 'Total des services de transport (hors TVA)',
      earlyPaymentDiscount: 'Escompte pour paiement anticipé {{percentage}}',
      earlyPaymentCondition:
        'En cas de paiement dans les 7 jours, un escompte de {{percentage}} ({{amount}}) est déduit. À payer : {{withDiscount}}. Après ce délai : {{withoutDiscount}}.',
      taxableAmount: 'Base imposable à {{rate}}',
      vat: 'TVA {{rate}}',
      totalToPay: 'Total à payer',
      paymentNotice:
        "{{amount}} sera viré automatiquement le {{date}} sur le compte {{iban}}. Aucune action n'est requise de votre part.",
      paymentNoticeWithoutAccount:
        "{{amount}} sera viré automatiquement le {{date}}. Aucune action n'est requise de votre part.",
      yourInvoiceTitle: 'Ceci est votre facture. Merci de ne pas nous envoyer de facture pour ces trajets.',
      yourInvoice:
        "Ce document est établi par {{customer}} au nom et pour le compte de {{supplier}}, conformément à la convention d'autofacturation entre les deux parties. Il ne s'agit pas d'une proposition. Une facture que vous enverriez vous-même pour les mêmes trajets sera refusée comme doublon.",
      acceptanceTitle: 'Acceptation',
      acceptance:
        'Cette facture est réputée acceptée par le fournisseur, sauf contestation écrite à {{email}} dans les 7 jours suivant la date de facture. Les corrections se font par une note de crédit en autofacturation.',
      paymentTermTitle: 'Délai de paiement',
      paymentTerm:
        'Le délai de paiement est celui convenu dans votre contrat. Si un escompte a été accordé, le délai de paiement est de 7 jours.',
      missingTripTitle: 'Un trajet manque ?',
      missingTrip:
        'Un trajet ne figure pas sur cette facture car ses documents ne sont pas en ordre. Téléchargez les bons documents dans le portail transporteur et le trajet sera repris sur votre prochaine autofacture.',
      questionsTitle: 'Des questions ?',
      questions: 'Contactez {{email}} en mentionnant le numéro de facture.',
      legalSelfBilling: 'Autofacturation',
      legalNotice:
        "{{selfBilling}} — facture émise par le client au nom et pour le compte du fournisseur (art. 224 et 226 (10 bis) Directive 2006/112/CE) · Convention d'autofacturation {{agreement}} · Peppol BIS Self-Billing 3.0, type de document 389",
      legalTerms:
        'Conditions générales de vente en annexe et disponibles sur {{website}} · Droit belge applicable · Tribunaux de Courtrai',
      pageFooter: '{{title}} {{number}} · {{company}}',
      page: 'Page {{page}} sur {{total}}',
    },
    creditNote: {
      creditNote: 'Note de crédit',
      customerNumber: 'Numéro de client',
      creditNoteNumber: 'Numéro de crédit',
      date: 'Date',
      dueDate: `Date d'échéance`,
      load: 'Chargement',
      unload: 'Déchargement',
      ourReference: 'Notre référence',
      yourReference: 'Votre référence',
      description: 'Description',
      quantity: 'Quantité',
      unitPrice: 'Prix unitaire',
      total: 'Total',
      vat: 'TVA',
      paymentInformation: 'Informations de paiement',
      amountToPay: 'Montant à payer',
      toBePaidBefore: 'À payer avant',
      payer: 'Payeur',
      message: 'Message',
      generalTermsAndConditions: 'Conditions générales de vente jointes',
      questionsOrComments: `Pour toute question, veuillez contacter le service comptabilité à l'adresse {{email}}`,
    },
    carrierTruckReport: {
      title: 'Rapport sur les performances des camions',
      truckname: 'Nom',
      totalIncome: 'Revenu total',
      totalKm: 'Kilomètres total',
    },
    totals: {
      totalExclVat: 'Total hors TVA',
      totalVat: 'Total TVA',
      totalInclVat: 'Total TTC',
      cashDiscount: 'Escompte',
      netAmountToPay: 'Montant net à payer',
      vatReverseCharged: 'VAT Reverse Charge, article 44 VAT Directive',
    },
  },
  carrierTerms: {
    agreement: "J'accepte les {{terms}}, y compris la procédure d'autofacturation.",
    termsLink: 'conditions générales',
  },
  pages: {
    confirmOrderStates: {
      headingRefused: 'La commande a été refusée',
      headingCancelled: 'La commande a été annulée',
      headingConfirmed: 'La commande a été confirmée',
      headingUnknownStatus: 'La commande a déjà été exécutée ou son état est inconnu',
    },
    confirmOrderPlanningStates: {
      headingRefused: 'La planification a été refusée',
      headingCancelled: 'La planification a été annulée',
      headingConfirmed: 'La planification a été confirmée',
      headingUnknownStatus: 'La planification a déjà été exécutée ou son statut est inconnu',
    },
    confirmOrder: {
      heading: `Confirmer l'ordre de transport {{order.orderNumber}}`,
      orderConfirmed: 'Commande confirmée',
      orderConfirmationError: 'Impossible de confirmer la commande: {{error}}',
      confirmButton: `Confirmer l'ordre de transport`,
    },
    confirmPlanning: {
      heading: `Confirmer planning {{order.orderNumber}}`,
      planningConfirmed: 'Commande confirmée',
      confirmButton: `Confirmer l'ordre de transport`,
    },
    refuseOrder: {
      heading: `Refuser l'ordre de transport {{order.orderNumber}}`,
      orderRefused: 'Commande confirmée',
      orderRefusalError: 'Impossible de refuser la commande: {{error}}',
      refuseButton: `Refuser l'ordre de transport`,
    },
    refusePlanning: {
      heading: 'Refuser la planification {{planningDate}}',
      planningRefused: 'Planification refusée',
      refuseButton: `Refuser la planification`,
    },
    orderSummary: {
      loadAndUnloadInformation: 'Informations de chargement et de déchargement',
      load: 'Charger',
      unload: 'Décharger',
      freightRate: 'Tarif de fret',
      total: 'Total',
    },
  },
  customerPortal: {
    switch: 'Changer de client',
    selectCustomer: 'Sélectionner un client',
    requestAccount: {
      title: 'Demander un compte',
      success: 'La demande a été envoyée, nous vous contacterons pour les étapes suivantes.',
      failed: 'Impossible de demander un compte: {{error}}',
      name: 'Nom',
      email: 'E-mail',
      companyName: "Nom de l'entreprise",
      companyNumber: "Numéro d'entreprise",
      request: 'Demander',
      dontHaveAnAccount: "Vous n'avez pas encore de compte?",
    },
    invite: {
      title: 'Invité au portail client',
      details:
        'Vous avez été invité au portail client de TransDirect, créez votre compte en entrant votre mot de passe.',
      accepted: "L'invitation a été acceptée, vous serez redirigé vers la page d'accueil sous peu.",
      acceptError: "Impossible d'accepter l'invitation: {{error}}",
      acceptButtonText: "Accepter l'invitation",
      password: 'Mot de passe',
      repeatPassword: 'Répétez le mot de passe',
    },
    home: {
      customerPortal: 'Portail client',
      title: 'Portail client de {{customerName}}',
      hello: 'Bonjour,',
      welcome: 'Bienvenue sur le portail client.',
      manageOrders: 'Gérez toutes vos commandes de transport.',
      viewInvoices: 'Consultez et payez vos factures facilement.',
      createQuotes: 'Créer et suivre des devis.',
      viewLocations: 'Voir tous les lieux de transport.',
    },
    locations: {
      locations: 'Lieux',
      location: 'Emplacement',
      name: 'Nom',
      street: 'Rue',
      number: 'Numéro',
      countryCode: 'Code pays',
      postalCode: 'Code postal',
      city: 'Ville',
      country: 'Pays',
      language: 'Langue',
      notes: 'Notes',
      createLocation: 'Créer un lieu',
      newLocation: 'Nouveau lieu',
      locationCreated: 'Lieu créé',
      couldNotCreateLocation: 'Impossible de créer le lieu : {{error}}',
      findLocation: 'Trouver un lieu...',
      address: 'Adresse',
      locationNotFound: 'Lieu non trouvé',
      couldNotLoadLocation: 'Impossible de charger le lieu : {{error}}',
    },
    order: {
      duplicate: 'Dupliquer',
      bulkDuplicate: 'Duplication en masse',
      bulkDuplicateTitle: 'Dupliquer la commande en masse',
      bulkDuplicateDescription: 'Créez plusieurs copies de cette commande avec des références de facture incrémentées.',
      numberOfDuplicates: 'Nombre de duplicatas',
      baseInvoiceRef: 'Référence de facture de départ',
      baseInvoiceRefHelper:
        'Base numérique. Les zéros en tête seront supprimés. Les références seront base à base+nombre-1.',
      skipDraft: 'Ignorer le statut brouillon (directement comme Créé)',
      bulkDuplicateSuccess: '{{count}} commandes créées',
      bulkDuplicateError: 'Impossible de dupliquer les commandes : {{error}}',
      referencePreview: 'Références : {{first}} à {{last}}',
      overview: 'Aperçu',
      updateInvoiceRef: 'Mettre à jour la référence de facture',
      updated: 'La commande a été mise à jour',
      couldNotUpdate: 'Impossible de mettre à jour la commande : {{error}}',
    },
    orders: {
      orders: 'Commandes',
      placeOrder: 'Passer une commande',
      invoiceRef: 'Référence de facture',
      orderRef: 'Référence de commande',
      loadLocation: 'Lieu de chargement',
      unloadLocation: 'Lieu de déchargement',
      loadDate: 'Date de chargement',
      loadTime: 'Heure de chargement',
      unloadDate: 'Date de déchargement',
      unloadTime: 'Heure de déchargement',
      invoiceTotal: 'Total de la facture',
      status: 'Statut',
      invoiceStatus: 'Statut de la facture',
      hasCMR: 'A un CMR',
      creationDate: 'Date de création',
      executionDate: "Date d'exécution",
      fileManager: 'Gestionnaire de fichiers',
      cancellationReason: "Motif d'annulation",
      stops: 'Arrêts',
      deleteStop: "Supprimer l'arrêt",
      purchases: 'Achats',
      total: 'Total',
      trailerTypes: 'Types de remorque',
      loadingMethod: 'Mode de chargement',
      load: 'Chargement',
      unload: 'Déchargement',
      typeStop: "Type d'arrêt",
      extraNotes: 'Notes supplémentaires',
      noContent: 'Pas de contenu',
      packaging: 'Emballage',
      coli: 'Coli',
      content: 'Contenu',
      addContent: 'Ajouter du contenu',
      deleteContent: 'Supprimer du contenu',
      noStops: "Pas d'arrêts",
      noStopsError: 'Ajoutez au moins un arrêt de chargement et de déchargement',
      reference: 'Référence',
      complaints: 'Réclamations',
      fileComplaint: 'Signaler une plainte',
      fileComplaintDescription: 'Remplissez ce formulaire pour signaler une plainte',
      send: 'Envoyer',
      reason: 'Raison',
      details: 'Détails',
      complaintFiled: 'Réclamation déposée',
      couldNotFileComplaint: 'Impossible de déposer une réclamation : {{error}}',
      placeAnOrder: 'Passer une commande',
      assignment: 'Tâche',
      addStop: 'Ajouter un arrêt',
      location: 'Lieu',
      date: 'Date',
      start: 'Début',
      stop: 'Fin',
      weight: 'Poids (kg)',
      volume: 'Volume (m3)',
      loadMeter: 'Mètre de charge',
      stopsRequired: 'Au moins 1 arrêt est requis',
      contentRequired: 'Au moins 1 élément de contenu est requis',
      truck: 'Truck',
      distance: 'Distance',
      emissions: 'Émissions',
      sustainability: 'Durabilité',
      attachments: 'Pièces jointes',
      uploadAttachments: 'Télécharger les pièces jointes',
      attachmentDeleted: 'Pièce jointe supprimée',
      couldNotDeleteAttachment: 'Impossible de supprimer la pièce jointe: {{error}}',
      uploadedAttachment: 'Pièce jointe {{document}} téléchargée',
      uploadFailed: 'Impossible de télécharger la pièce jointe {{document}}: {{error}}',
      route: 'Itinéraire',
      chooseMethod: 'Choisir une méthode',
      automatic: 'Automatique',
      automaticDescription:
        "Téléchargez un ou plusieurs PDFs d'ordres de transport et notre IA extraira automatiquement les détails de la commande. Chaque PDF devient une commande distincte.",
      manual: 'Manuel',
      manualDescription:
        'Remplissez le formulaire de commande vous-même avec tous les arrêts, le fret et les détails de livraison.',
      uploadPdfs: "Télécharger les PDFs d'ordres de transport",
      processingPdf: 'Traitement du PDF...',
      createOrders: 'Créer les commandes',
      orderCreated: 'Commande créée',
      ordersCreated: '{{count}} commandes créées',
      couldNotCreateFromPdf: 'Impossible de créer la commande à partir du PDF: {{error}}',
      uploadAtLeastOnePdf: 'Téléchargez au moins un PDF',
      viewOrder: 'Voir la commande',
      creatingOrders: 'Création des commandes...',
      report: 'Rapport',
      orderPlaced: 'Commande passée',
      couldNotPlaceOrder: 'Impossible de passer la commande : {{error}}',
      stopNumber: 'Arrêt {{number}} - {{type}}',
      orderLink: 'Commande {{orderNumber}} - {{customerRef}}',
    },
    quotes: {
      quotes: 'Devis',
      quote: 'Devis',
      quoteReference: 'Référence du devis',
      quoteDate: 'Date du devis',
      expirationDate: "Date d'expiration",
      total: 'Total',
      search: 'Rechercher un devis...',
      quotation: 'Devis {{reference}}',
      notFound: 'Devis non trouvé',
      departurePlace: 'Lieu de départ',
      destination: 'Destination',
      distance: 'Distance',
      price: 'Prix',
      type: 'Type',
      requests: 'Demander des devis',
      request: 'Demander un devis',
      notes: 'Notes',
      lines: 'Lignes de devis',
      addLine: 'Ajouter une ligne',
      noLines: 'Aucune ligne de devis',
      requestTitle: 'Devis {{reference}}',
      requestSuccess: 'Devis demandé',
      requestFailed: 'Impossible de demander un devis : {{error}}',
      quotationRequests: 'Demandes de devis',
      requestedAt: 'Demandé à',
      hasQuote: 'A un devis',
      generalInformation: 'Informations générales',
      removeLine: 'Supprimer la ligne',
    },
    quoteLine: {
      from: 'De',
      to: 'À',
    },
    invoices: {
      invoices: 'Factures',
      invoiceNumber: 'Numéro de facture',
      invoiceDate: 'Date de facture',
      dueDate: "Date d'échéance",
      total: 'Total',
      search: 'Rechercher une facture...',
      notFound: 'Facture non trouvée',
      invoice: 'Facture {{invoiceNumber}}',
      structuredComment: 'Commentaire structuré',
      reference: 'Référence',
      sentAt: 'Envoyée le',
      load: 'Chargement',
      unload: 'Déchargement',
      description: 'Description',
      amount: 'Quantité',
      unitPrice: 'Prix unitaire',
      vat: 'TVA',
      extraInformation: 'Informations supplémentaires: {{extraInformation}}',
      orderTotal: 'Total de la commande: €{{total}}',
      totalExclVat: 'Total HT:',
      totalVat: 'Total TVA:',
      totalInclVat: 'Total TTC:',
      generalInformation: 'Informations générales',
    },
    creditNotes: {
      creditNotes: 'Notes de crédit',
      creditNoteNumber: 'Numéro de note de crédit',
      creditNoteDate: 'Date de note de crédit',
      dueDate: "Date d'échéance",
      total: 'Total',
      search: 'Rechercher une note de crédit...',
      notFound: 'Note de crédit non trouvée',
      creditNote: 'Note de crédit {{creditNoteNumber}}',
      structuredComment: 'Communication structurée',
      reference: 'Référence',
      sentAt: 'Envoyé le',
      load: 'Charger',
      unload: 'Décharger',
      description: 'Description',
      amount: 'Montant',
      unitPrice: 'Prix unitaire',
      vat: 'TVA',
      extraInformation: 'Informations supplémentaires: {{extraInformation}}',
      orderTotal: 'Total de la commande: €{{total}}',
      totalExclVat: 'Total hors TVA:',
      totalVat: 'Total TVA:',
      totalInclVat: 'Total TVA incluse:',
      generalInformation: 'Informations générales',
    },
    businessInformation: {
      businessInformation: "Informations sur l'entreprise",
      updateBusinessInformation: "Mettre à jour les informations de l'entreprise",
      name: 'Nom',
      vatNumber: 'Numéro de TVA',
      businessNumber: "Numéro d'entreprise",
      saveChanges: 'Sauvegarder les modifications',
      informationChanged: 'Les informations ont été mises à jour',
      informationNotChanged: 'Impossible de mettre à jour les informations : {{error}}',
      requestChanges: `Pour mettre à jour le nom de l'entreprise, le numéro de TVA ou le numéro d'entreprise, veuillez nous contacter.`,
    },
    ourInformation: {
      ourInformation: `Informations d'entreprise TransDirect`,
      name: 'Nom',
      vatNumber: 'Numéro de TVA',
      businessNumber: "Numéro d'entreprise",
      address: 'Adresse',
      contact: 'Contact',
      phoneNumber: 'Numéro de téléphone',
      emailTransport: 'Email transport',
      emailAccounting: 'Email comptabilité',
      emailGeneral: 'Email général',
    },
    contacts: {
      contacts: 'Contacts',
      name: 'Nom',
      email: 'E-mail',
      phone: 'Téléphone',
      function: 'Fonction',
      language: 'Langue',
      notifications: 'Notifications',
      newContact: 'Nouveau contact',
      contactCreated: 'Contact créé',
      couldNotCreateContact: 'Impossible de créer le contact: {{error}}',
      createContact: 'Créer un contact',
      notFound: 'Contact non trouvé',
      updatedContact: 'Contact mis à jour',
      couldNotUpdateContact: 'Impossible de mettre à jour le contact : {{error}}',
      updateContact: 'Mettre à jour le contact',
      delete: 'Supprimer',
      deleteContact: 'Supprimer le contact',
      deleteContactConfirmation: 'Êtes-vous sûr de vouloir supprimer le contact {{name}}?',
      deleteContactError: 'Impossible de supprimer le contact: {{error}}',
      deleteContactSuccess: 'Contact supprimé',
    },
    users: {
      users: 'Utilisateurs',
      inviteUser: 'Inviter un utilisateur',
      invitedUsers: 'Utilisateurs invités',
      noInvitedUsers: 'Aucun utilisateur invité',
      removeInvite: "Supprimer l'invitation",
      confirmRemoveInvite: "Êtes-vous sûr de vouloir supprimer l'invitation pour {{email}}?",
      inviteRemoved: 'Invitation supprimée',
      couldNotRemoveInvite: "Impossible de supprimer l'invitation : {{error}}",
      noUsersFound: 'Aucun utilisateur trouvé',
      removeUser: "Supprimer l'utilisateur",
      confirmRemoveUser: "Êtes-vous sûr de vouloir supprimer l'utilisateur {{name}}?",
      userRemoved: 'Utilisateur supprimé',
      couldNotRemoveUser: "Impossible de supprimer l'utilisateur : {{error}}",
      active: 'Actif',
      inactive: 'Inactif',
      userInvited: 'Utilisateur invité',
      couldNotInviteUser: "Impossible d'inviter l'utilisateur : {{error}}",
      name: 'Nom',
      email: 'E-Mail',
      isActive: 'Est actif?',
      invited: 'Invité',
    },
    cmrReminder: {
      cmrReminder: 'Rappel CMR',
      sendReminder: 'Envoyer',
      confirmText: 'Êtes-vous sûr de vouloir envoyer un rappel CMR ?',
      confirmation: 'Rappel CMR envoyé',
      error: "Impossible d'envoyer le rappel CMR : {{error}}",
    },
    sustainability: {
      sustainability: 'Durabilité',
      policy: 'Politique de durabilité',
      viewOverview: "Voir l'aperçu de la durabilité",
      orderCount: 'Nombre de commandes',
      totalDistance: 'Distance totale',
      totalWeight: 'Poids total',
      totalEmissions: 'Émissions totales de CO2',
      averageDistance: 'Distance moyenne',
      averageWeight: 'Poids moyen',
      averageEmissions: 'Émissions moyennes',
      total: 'Total',
      avgPerOrder: 'Moyenne par commande',
    },
    settings: {
      settings: 'Paramètres',
    },
    apiKeys: {
      apiKeys: 'Clés API',
      createApiKey: 'Créer une clé API',
      name: 'Nom',
      scopes: 'Autorisations',
      status: 'Statut',
      lastUsed: 'Dernière utilisation',
      createdAt: 'Créée le',
      prefix: 'Préfixe',
      active: 'Active',
      revoked: 'Révoquée',
      expired: 'Expirée',
      never: 'Jamais',
      revokeApiKey: 'Révoquer la clé API',
      confirmRevoke: 'Êtes-vous sûr de vouloir révoquer la clé API "{{name}}" ? Cette action est irréversible.',
      apiKeyRevoked: 'La clé API a été révoquée',
      couldNotRevoke: 'Impossible de révoquer la clé API : {{error}}',
      apiKeyCreated: 'La clé API a été créée',
      couldNotCreate: 'Impossible de créer la clé API : {{error}}',
      copyKey: 'Copier la clé',
      keyCopied: 'Clé copiée',
      keyWarning: 'Conservez cette clé en lieu sûr. Elle ne sera plus affichée.',
      noApiKeys: 'Aucune clé API trouvée',
      ordersRead: 'Lire les commandes',
      ordersWrite: 'Créer des commandes',
      maxKeysReached: 'Nombre maximum de clés API atteint',
      scopeRequired: 'Au moins une portée est requise',
    },
    loading: 'Chargement...',
  },
  liveTracking: {
    title: 'Suivi',
    subtitle: 'Position et ordinateur de bord de ce camion.',
    loading: 'Récupération de la position…',
    noPosition: 'Aucune position connue pour ce camion.',
    noPositionHint: 'Associez un véhicule à cette plaque sur la page des intégrations.',
    noConnection: 'Aucune connexion de suivi ne suit encore ce camion. Connectez-en une pour voir sa position.',
    driving: 'Roule',
    idle: 'À l’arrêt',
    location: 'Position',
    speed: 'Vitesse',
    heading: 'Direction',
    odometer: 'Compteur',
    fuel: 'Carburant',
    lastMeasurement: 'Dernière mesure',
    liveActive: 'Suivi en direct actif — actualisation toutes les 30 secondes.',
    lastSignal: 'Dernier signal',
    trailer: 'Remorque',
    refresh: 'Actualiser',
    startLive: 'Démarrer le suivi en direct',
    stopLive: 'Arrêter le suivi en direct',
    resizePanel: 'Redimensionner le panneau latéral',
    connections: 'Connexions de suivi',
    connectionsSubtitle: 'Connectez l’environnement de suivi d’un fournisseur pour suivre ses camions.',
    addConnection: 'Ajouter une connexion de suivi',
    integrations: 'Intégrations de suivi',
    integrationsHint: 'Choisissez un fournisseur pour connecter le suivi d’un transporteur.',
    providerFleetmaster: 'Suivez la position et l’ordinateur de bord des camions via FleetMaster.lt.',
    connectionLabel: 'Nom',
    connectionLabelHelp: 'Le nom sous lequel cette connexion apparaît dans la liste.',
    helpCompanyId: 'Identifiant de société de votre compte télématique FleetMaster.',
    helpSuivoBaseUrl: 'Laisser vide pour l’environnement Suivo standard.',
    ownerLabel: 'ID du fournisseur',
    ownerHelp: 'Pour une connexion appartenant à un affrété/fournisseur.',
    credentialsNote: 'La clé est stockée chiffrée et n’est plus jamais affichée après l’enregistrement.',
    connect: 'Connecter',
    back: 'Retour',
    noConnections: 'Aucune connexion de suivi.',
    noConnectionsHint: 'Ajoutez-en une pour voir où sont les camions.',
    moreConnectionsTitle: 'D’autres connexions de suivi arrivent bientôt',
    moreConnectionsBody:
      'FleetMaster est le premier fournisseur. Nous travaillons sur d’autres connexions de suivi — les nouveaux fournisseurs apparaissent ici automatiquement.',
    connectionsLoading: 'Chargement des connexions…',
    vehiclesLoading: 'Chargement des véhicules…',
    noVehicles: 'Cette connexion ne signale encore aucun véhicule.',
    statusActive: 'Actif',
    statusError: 'Erreur',
    keyLabel: 'clé',
    linkedCount: '{{linked}} sur {{total}} véhicules associés',
    lastChecked: 'dernière vérification',
    never: 'jamais',
    supplierOwner: 'Fournisseur #{{id}}',
    connectionSettings: 'Paramètres de connexion',
    verify: 'Vérifier',
    verifyOk: 'La connexion fonctionne.',
    verifyFailed: 'La connexion n’a pas pu être vérifiée.',
    remove: 'Supprimer',
    removeTitle: 'Supprimer la connexion',
    removeDescription: 'La connexion « {{label}} » et la clé enregistrée seront supprimées.',
    connectionRemoved: 'Connexion supprimée.',
    linkVehicles: 'Associer des véhicules',
    linkVehiclesHint: 'Choisissez un véhicule, puis le camion dans lequel il roule.',
    link: 'Associer',
    unlink: 'Dissocier',
    linkTruck: 'Associer un camion',
    chooseTruck: 'Camion',
    chooseTruckHelp: 'Choisissez le camion dans lequel roule ce véhicule.',
    chooseTruckRequired: 'Choisissez un camion',
    moreTrucks: 'Seuls les {{count}} premiers camions sont affichés — recherchez pour affiner la liste.',
    plateMatch: 'plaque correspondante',
    linkedTo: 'Associé à {{truck}}',
    linkedManually: 'manuel',
    notLinked: 'Non associé',
    vehicleLinked: 'Véhicule associé.',
    vehicleUnlinked: 'Association supprimée.',
    trailerSubtitle: 'Position de cette remorque.',
    linkTracker: 'Associer un traceur',
    linkTrackerHint: 'Choisissez le véhicule installé dans cette remorque.',
    linkTrailer: 'Associer une remorque',
    linkTrailerHint: 'Choisissez un véhicule, puis la remorque sur laquelle il se trouve.',
    chooseTrailer: 'Remorque',
    chooseTrailerRequired: 'Choisissez une remorque',
    noTrackerLinked: "Aucun traceur n'est encore associé à cette remorque — associez-en un pour voir sa position.",
    noTrailerPosition: 'Aucune position connue pour cette remorque.',
    searchUnits: 'Rechercher par nom ou plaque…',
    noUnits: 'Aucun véhicule signalé.',
    providerSuivo: 'Suivez la position de nos remorques avec les trackers Suivo.',
    ownerKindLabel: 'Propriétaire',
    ownerKindCompany: 'Flotte propre (entreprise)',
    ownerKindCarrier: 'Transporteur/fournisseur',
    supplierOwnerCompany: 'Flotte propre',
    status: {
      moving: 'En route',
      parked: 'Garé',
      idling: 'Au ralenti',
      immobilized: 'Immobilisé',
      offline: 'Aucun signal',
      inOperation: 'En service',
    },
    trailersMap: {
      searchLabel: 'Rechercher (ID TDR / nom / plaque)',
      searchPlaceholder: 'Rechercher par nom ou plaque...',
      trackerLabel: 'Traceur',
      trackerAll: 'Toutes les remorques',
      trackerTracked: 'Avec traceur',
      trackerUntracked: 'Sans traceur',
      trackerSilent: 'Aucun signal > 24 h',
      tableCardTitle: 'Remorques',
      mapCardTitle: 'Carte',
      tableTrailer: 'Remorque',
      tablePlate: 'Plaque',
      tableTracker: 'Traceur',
      tableStatus: 'Statut',
      tableLastSignal: 'Dernier signal',
      tablePlace: 'Lieu',
      noTracker: 'Aucun traceur',
      clearFilters: 'Effacer tous les filtres',
      noneTrackedTitle: 'Aucun traceur associé',
      noneTrackedDescription: 'Associez une unité Suivo à une remorque pour la voir sur la carte.',
      noneInFilter: 'Aucune remorque dans cette sélection',
      noConnectionsTitle: 'Aucune connexion de suivi',
      noConnectionsDescription: 'Ajoutez une connexion pour voir où se trouvent nos remorques.',
      noConnectionsAction: 'Vers les intégrations de suivi',
      connectionErrorTitle: 'Connexion de suivi en erreur',
    },
  },
  carrierPortal: {
    liveTracking: { liveTracking: 'Suivi' },
    selectCarrier: 'Sélectionner transporteur',
    loading: 'Chargement...',
    switch: 'Changer de transporteur',
    home: {
      carrierPortal: 'Portail Transporteur',
      title: 'Portail Transporteur',
      hello: 'Bonjour,',
      welcome: 'Bienvenue sur le portail transporteur.',
      manageOrders: 'Gérez toutes vos commandes de transport.',
      managePlanning: 'Gérez votre planning.',
      selfBilling: 'Créez et gérez vos factures self-billing.',
      info: 'Informations',
      infoSubtitle: 'Informations sur TransDirect & le portail transporteur',
      contact: 'Contact',
      contactSubtitle: 'Qui est votre contact TransDirect',
      FuelCard: 'Carte carburant',
      FuelCardSubtitle: 'Demandez votre carte carburant TransDirect personnalisée',
      saveChanges: 'Enregistrer les modifications',
    },
    orders: {
      allAccepted: 'Toutes les commandes confirmées',
      customerReference: 'Référence client',
      draft: 'Brouillon',
      load: 'Chargement',
      orders: 'Commandes',
      manageOrders: 'Gérez tous vos transports et téléchargez vos documents de transport',
      orderRef: 'Référence TD',
      loadLocation: 'Lieu de chargement',
      unload: 'Déchargement',
      unloadLocation: 'Lieu de déchargement',
      invoiceTotal: 'Tarif de fret',
      hasCMR: 'A des documents',
      documents: 'Documents',
      cmrRejected: 'Refusé',
      cmrPending: 'En cours',
      cmrUploadHint: 'Vous pouvez téléverser un ou plusieurs fichiers PDF ; nous les fusionnerons en un seul document.',
      cmrUploaded: 'Document téléversé',
      cmrUploadFailed: 'Impossible de téléverser le document : {{error}}',
      documentValidation: 'Documents',
      documentValidationNoDocuments: 'Aucun document',
      documentValidationPending: 'En cours',
      documentValidationApproved: 'Approuvé',
      documentValidationRejected: 'Refusé',
      outstandingDocsTitle: 'Documents encore à fournir',
      requiredDocMissing: 'manquant',
      requiredDocInReview: 'en traitement',
      requiredDocRejected: 'refusé — veuillez téléverser à nouveau',
      requiredDocStatusReceived: 'Reçu',
      requiredDocStatusInReview: 'En cours de validation',
      requiredDocStatusRejected: 'Refusé',
      requiredDocStatusMissing: 'Manquant',
      requiredDocsTitle: 'Documents obligatoires',
      requiredDocsSubtitle: 'Ce client exige les documents ci-dessous pour cette commande.',
      requiredDocsProgress: '{{done}} sur {{total}} reçus',
      requiredDocReupload: 'Téléverser à nouveau',
      uploadDocumentTitle: 'Téléverser {{document}}',
      uploadRequiredDoc: 'Téléverser',
      uploadDocumentsTitle: 'Téléverser des documents',
      uploadDocumentsHint:
        'Téléversez un ou plusieurs fichiers à la fois ; nous les séparons et classons chaque partie sous le bon type de document.',
      docReasonInReview: 'en cours de vérification',
      docReasonRejected: 'refusé',
      docRejectionLowQuality: 'illisible',
      docRejectionMissingSignature: 'signature manquante',
      docRejectionNoOrderReference: 'aucune référence trouvée',
      docRejectionNotNeutral: 'CMR non neutre',
      docRejectionWrongCustomer: 'mauvais client',
      docRejectionWrongDeliveryAddress: 'mauvaise adresse de livraison',
      docRejectionWrongDocumentType: 'mauvais type de document',
      docRejectionWrongOrgOnDocument: 'mauvaise société',
      requiredDocUploaded: 'Document téléversé',
      requiredDocUploadFailed: 'Échec du téléversement du document : {{error}}',
      purchases: 'Tarif de fret',
      reference: 'Référence',
      assignee: 'Assigné à',
      orderAssigned: 'Commande assignée',
      changeAssignee: 'Modifier',
      assignOrder: 'Assigner la commande',
      assign: 'Assigner',
      route: 'Itinéraire',
      error: 'Erreur',
      report: 'Rapport',
    },
    planning: {
      acceptAll: 'Tout accepter',
      actions: 'Actions',
      date: 'Date',
      loadingOrders: 'Chargement des commandes...',
      noTruck: "Ce transporteur n'a pas encore de camion.",
      ordersForTruck: 'Commandes pour le camion avec la plaque {{licensePlate}}',
      planning: 'Planning',
      truck: 'Camion',
      managePlanning: 'Consultez et gérez votre planning de transport',
    },
    selfBilling: {
      selfBilling: 'Self Billing',
      rideOverview: 'Aperçu des trajets',
      manageRideOverview: 'Consultez et téléchargez vos aperçus des trajets',
      searchRideOverviewPlaceholder: 'Rechercher un aperçu des trajets...',
      type: 'Type',
      number: 'Numéro',
      manageSelfBilling: 'Consultez et téléchargez votre Self Billing',
      searchPlaceholder: 'Rechercher un self billing...',
      id: 'Référence',
      date: 'Date',
      download: 'Télécharger',
      invoice: 'Facture',
      title: 'Facture Self Billing',
    },
    businessInformation: {
      businessInformation: 'Informations commerciales',
      settingsAndBusinessInformation: 'Paramètres et informations commerciales',
      tabGeneral: 'Général',
      tabFleet: 'Flotte',
      tabContacts: 'Contacts',
      civilLiabilityInsurance: 'Assurance responsabilité civile',
      CMRInsurance: 'Assurance CMR',
      transportationInsurance: 'Assurance transport',
      documentUploaded: 'Document téléchargé',
      insurances: 'Assurances',
    },
    generalInformation: {
      generalInformation: 'Informations',
      noDocumentsAvailable: 'Aucun document disponible',
      checkBackLater: 'Revenez plus tard pour une documentation mise à jour',
    },

    contacts: {
      contacts: 'Contacts',
      newContact: 'Nouveau contact',
      updateContact: 'Enregistrer le contact',
      name: 'Nom',
      email: 'E-mail',
      phone: 'Téléphone',
      function: 'Fonction',
      language: 'Langue',
      delete: 'Supprimer',
      createContactSuccess: 'Contact créé avec succès',
      createContactError: 'Impossible de créer le contact : {{error}}',
      updateContactSuccess: 'Contact mis à jour avec succès',
      updateContactError: 'Impossible de mettre à jour le contact : {{error}}',
      deleteContact: 'Supprimer le contact',
      deleteContactConfirmation: 'Êtes-vous sûr de vouloir supprimer votre contact ?',
      deleteContactSuccess: 'Contact supprimé avec succès',
      deleteContactError: 'Impossible de supprimer le contact : {{error}}',
      notFound: 'Contact non trouvé',
      notifications: 'Notifications',
    },
    trucks: {
      title: 'Tracteurs',
      newTruck: 'Nouveau tracteur',
      update: 'Mettre à jour le tracteur',
      licensePlate: "Plaque d'immatriculation",
      codeName: 'Nom de code',
      planner: 'Planificateur',
      isActive: 'Actif',
      insuranceExpiresAt: 'Assurance expire le',
      examinationExpiresAt: 'Examen expire le',
      documents: 'Documents',
      yes: 'Oui',
      no: 'Non',
      moveUp: 'Monter',
      moveDown: 'Descendre',
      create: 'Créer',
      succeeded: 'Tracteur enregistré',
      createError: 'Impossible de créer le tracteur : ',
      updateError: 'Impossible de mettre à jour le tracteur : ',
      insurance: 'Assurance',
      insuranceUploaded: 'Assurance enregistrée',
      examination: 'Examen',
      examinationUploaded: 'Examen enregistrée',
      notFound: 'Aucun tracteur trouvé',
      appLoginTitle: 'Connexion app chauffeur',
      appLoginHint:
        "Les chauffeurs se connectent avec la plaque d'immatriculation. Définissez le mot de passe ici ; ils ne peuvent pas le réinitialiser eux-mêmes.",
      appPasswordLabel: 'Mot de passe app chauffeur',
      appLoginLabel: "Identifiant (plaque d'immatriculation)",
      appCodeNameLabel: 'Nom de code',
      appSavePassword: 'Enregistrer le mot de passe',
      appDisableLogin: 'Désactiver la connexion',
      appPasswordSaved: 'Mot de passe enregistré',
      appLoginDisabled: 'Connexion app chauffeur désactivée',
      detailsTitle: 'Détails du tracteur',
      documentCount: '{{count}} sur {{total}}',
      statusValid: 'Valide',
      statusExpiringSoon: 'Expire bientôt',
      statusExpired: 'Expiré',
      statusMissing: 'Manquant',
      expiresOn: 'Expire le {{date}}',
      noDocument: 'Aucun document téléversé',
      viewDocument: 'Consulter',
      replaceDocument: 'Remplacer',
      uploadDocument: 'Téléverser',
      searchPlaceholder: 'Rechercher par plaque…',
      noExpiryKnown: 'Aucune date d’expiration connue',
      notUploadedYet: 'Pas encore téléversé',
    },
    trailers: {
      title: 'Remorques',
      truckAmount: 'Nombre de tracteurs',
      tautlinerAmount: 'Nombre de remorques rideau',
      boxTrailerAmount: 'Nombre de remorques fourgon/refrigérées',
      openTrailerAmount: 'Nombre de remorques ouvertes',
      save: 'Enregistrer les modifications',
      saveSuccess: 'Transporteur mis à jour',
      saveError: 'Impossible de mettre à jour le transporteur : {{error}}',
      subtitle: 'Quantités par type — utilisées pour la planification de capacité',
    },
    driverBlock: {
      title: 'Accès chauffeur',
      message: "Veuillez vous connecter à l'application chauffeur sur votre mobile pour consulter vos commandes.",
    },
    notFound: {
      pageNotFound: 'Page non trouvée.',
      pageNotFoundDesc:
        "Cette page semble ne pas exister. Si vous pensez qu'il y a un problème, veuillez contacter votre contact TransDirect.",
    },
    invite: {
      title: 'Invité au portail transporteur',
      details:
        'Vous avez été invité au portail transporteur de TransDirect, créez votre compte en entrant votre mot de passe.',
      accepted: "L'invitation a été acceptée, vous serez redirigé vers la page d'accueil sous peu.",
      acceptError: "Impossible d'accepter l'invitation : {{error}}",
      acceptButtonText: "Accepter l'invitation",
      password: 'Mot de passe',
      repeatPassword: 'Répétez le mot de passe',
    },
    users: {
      users: 'Utilisateurs',
      inviteUser: 'Inviter un utilisateur',
      invitedUsers: 'Utilisateurs invités',
      noInvitedUsers: 'Aucun utilisateur invité',
      removeInvite: "Supprimer l'invitation",
      confirmRemoveInvite: "Êtes-vous sûr de vouloir supprimer l'invitation pour {{email}} ?",
      inviteRemoved: 'Invitation supprimée',
      couldNotRemoveInvite: "Impossible de supprimer l'invitation : {{error}}",
      noUsersFound: 'Aucun utilisateur trouvé',
      removeUser: "Supprimer l'utilisateur",
      confirmRemoveUser: "Êtes-vous sûr de vouloir supprimer l'utilisateur {{name}} ?",
      userRemoved: 'Utilisateur supprimé',
      couldNotRemoveUser: "Impossible de supprimer l'utilisateur : {{error}}",
      active: 'Actif',
      inactive: 'Inactif',
      userInvited: 'Utilisateur invité',
      couldNotInviteUser: "Impossible d'inviter l'utilisateur : {{error}}",
      name: 'Nom',
      email: 'E-mail',
      isActive: 'Est actif ?',
      role: 'Rôle',
      roleDispatcher: 'Dispatcheur',
      roleDriver: 'Chauffeur',
      activeUsers: 'Utilisateurs actifs',
      pendingInvitations: 'Invitations en attente',
      sendInvitation: "Envoyer l'invitation",
      sending: 'Envoi en cours...',
      cancel: 'Annuler',
      emailAddress: 'Adresse e-mail',
      deleteInvitation: "Supprimer l'invitation",
      joined: 'Rejoint',
      invited: 'Invité',
      assignee: 'Assigné à',
      assignOrder: 'Assigner la commande',
      unassigned: 'Non assigné',
      assignedTo: 'Assigné à',
      roleUpdated: 'Rôle mis à jour',
      renameUser: "Renommer l'utilisateur",
      newName: 'Nouveau nom',
      userRenamed: 'Utilisateur renommé',
      save: 'Enregistrer',
      permissions: 'Autorisations',
      canRenameUsers: 'Peut renommer les utilisateurs',
      permissionsUpdated: 'Autorisations mises à jour',
      nameOptional: 'Nom (optionnel)',
      emailRequired: 'Veuillez saisir une adresse e-mail',
      namePlaceholder: 'Jean Dupont',
      emailPlaceholder: 'utilisateur@exemple.com',
    },
    tracking: {
      loading: 'Chargement des événements de suivi...',
      events: 'Événements de suivi',
      noEvents: 'Aucun événement de suivi trouvé',
      scheduled: 'Prévu',
      eventTypes: {
        StatusLoaded: 'Chargé',
        StatusUnloaded: 'Déchargé',
        LocationPing: 'Mise à jour de la position',
      },
      stop: 'Arrêt',
      by: 'par',
    },
  },
  orderStatus: {
    Draft: 'Brouillon',
    Created: 'Créé',
    Prepayment: 'Prépaiement',
    Placed: 'Placé',
    Confirmed: 'Confirmé',
    Refused: 'Refusé',
    Executed: 'Exécuté',
    Cancelled: 'Annulé',
  },
  orderSaleStatus: {
    Created: 'Créé',
    Credited: 'Crédité',
    Incomplete: 'Incomplet',
    Invoiced: 'Facturé',
  },
  customerContactNotifications: {
    invoice: 'Facturation',
    orderConfirmation: 'Confirmation de commande',
    cmr: 'CMR',
    quotation: 'Devis',
    dieselSurcharge: 'Supplément diesel',
    paymentReminder: 'Rappel de paiement',
  },
  errors: {
    required: 'Requis',
    invalidEmail: 'E-mail invalide',
    dateShouldBeInTheFuture: 'La date doit être dans le futur',
    startTimeShouldBeBeforeEndTime: "L'heure de début doit être antérieure à l'heure de fin",
    passwordsDontMatch: 'Le mot de passe et la confirmation ne correspondent pas.',
    passwordTooShort: 'Le mot de passe est trop court.',
    formValidation: 'Veuillez vérifier les champs en surbrillance dans le formulaire',
    retry: 'Réessayer',
    reloadPage: 'Recharger la page',
    networkTitle: 'Problème de connexion',
    networkDescription: 'Nous ne pouvons pas joindre le serveur. Vérifiez votre connexion internet et réessayez.',
    serverTitle: 'Erreur serveur',
    serverDescription: "Le serveur n'a pas pu traiter votre demande. Veuillez réessayer plus tard.",
    notFoundTitle: 'Introuvable',
    notFoundDescription: "Les données demandées n'existent plus ou ne sont pas disponibles.",
    sessionTitle: 'Session expirée',
    sessionDescription: 'Votre session a expiré ou vous n’êtes pas connecté. Connectez-vous à nouveau pour continuer.',
    permissionTitle: 'Accès refusé',
    permissionDescription: "Vous n'avez pas accès à ces données.",
    validationTitle: 'Données invalides',
    validationDescription: 'Veuillez vérifier les données saisies et réessayer.',
    rateLimitTitle: 'Trop de requêtes',
    rateLimitDescription: 'Trop de requêtes ont été envoyées. Patientez un instant et réessayez.',
    abortedTitle: 'Requête annulée',
    abortedDescription: 'La requête a été annulée. Réessayez si nécessaire.',
    unknownTitle: 'Erreur inconnue',
    unknownDescription: 'Une erreur inattendue est survenue. Réessayez ou contactez le support si cela continue.',
    loadingTitle: 'Échec du chargement',
    loadingDescription: "Les données n'ont pas pu être chargées.",
  },
  orderComplaintType: {
    Aggression: 'Agression physique/verbale',
    DamagedGoods: 'Marchandises endommagées',
    IncorrectDelivery: 'Livraison incorrecte',
    IncorrectInvoice: 'Facture incorrecte',
    LateDelivery: 'Livraison tardive',
    Other: 'Autre',
  },
  myProfile: {
    myProfile: 'Mon profil',
    logout: 'Déconnexion',
    name: 'Nom',
    role: 'Rôle',
    email: 'Email',
    language: 'Langue',
    languageChanged: 'Langue mise à jour',
    languageNotChanged: 'Impossible de mettre à jour la langue : {{error}}',
    joinedAt: 'Inscrit le',
    nameChanged: 'Le nom a été mis à jour',
    nameNotChanged: 'Impossible de mettre à jour le nom : {{error}}',
  },
  auth: {
    forgotPassword: {
      title: 'Mot de passe oublié',
      requestNewPassword: 'Demander un nouveau mot de passe',
      instructions:
        "Entrez votre e-mail, si l'utilisateur existe dans le système, vous recevrez bientôt un e-mail pour définir un nouveau mot de passe.",
      requestFailed: 'Impossible de demander un nouveau mot de passe',
      instructionsSent:
        'Les instructions pour définir un nouveau mot de passe ont été envoyées à votre adresse e-mail.',
    },
    configNewPassword: {
      title: 'Définir un nouveau mot de passe',
      newPassword: 'Nouveau mot de passe',
      repeatNewPassword: 'Répétez le nouveau mot de passe',
      confirmButtonText: 'Définir le nouveau mot de passe',
      passwordDontMatch: 'Le mot de passe et la répétition du mot de passe doivent correspondre',
      tokenNotFound: 'Jeton non trouvé',
      invalidToken: "Le jeton n'est plus valide",
      configFailed: 'Impossible de définir le mot de passe : {{error}}',
    },
    login: {
      login: 'Connexion',
      email: 'E-mail',
      password: 'Mot de passe',
      forgotPassword: 'Mot de passe oublié',
      customerLoginTitle: 'Connexion client',
      loginWithGoogle: 'Se connecter avec Google',
      incorrectCredentials: 'E-mail ou mot de passe incorrect',
      loginFailed: 'Impossible de se connecter : {{error}}',
    },
    userNotFound: {
      title: 'Utilisateur non trouvé',
      description: "Impossible de se connecter, une erreur s'est produite ou l'utilisateur n'existe plus.",
      goToLoginPage: 'Aller à la page de connexion',
    },
  },
  upload: {
    title: 'Télécharger',
    dropzoneHint: 'Cliquez ici ou déposez le(s) fichier(s) dans la zone pour téléverser',
    uploadDocuments: 'Télécharger des documents',
    confirmDeleteDocument: 'Êtes-vous sûr de vouloir supprimer ce document?',
    deleteDocument: 'Supprimer le document',
    noDocumentsFound: 'Aucun document trouvé',
    noDocumentsSelected: 'Aucun document sélectionné',
    uploadFailed: 'Impossible de télécharger le document',
    uploadDocumentFailed: 'Impossible de télécharger le fichier {{filename}}: {{reason}}',
    multiUploadFailed: 'Impossible de télécharger les fichiers: {{reason}}',
  },
  portal: {
    requestAccount: {
      requestCustomerAccount: 'Vraag een account aan als opdrachtgever',
      requestCarrierAccount: 'Vraag een account aan als vervoerder',
      success: 'Aanvraag is verzonden, we zullen u contacteren voor verdere stappen.',
      failed: 'Kon account niet aanvragen: {{error}}',
      name: 'Naam',
      email: 'Email',
      companyName: 'Bedrijfsnaam',
      companyNumber: 'Ondernemingsnummer',
      request: 'Vraag aan',
      dontHaveAnAccount: 'Heeft u nog geen account?',
      accountRequestFailed: 'Échec de la demande de compte',
    },
  },
  carrierContactNotifications: {
    transportOrders: 'Commandes de transport',
    selfBillings: 'Self Billings',
  },
  or: 'ou',
  draft: 'Brouillon',
  cancel: 'Annuler',
  close: 'Fermer',
  moreInfo: "Plus d'infos",
  previous: 'Précédent',
  next: 'Suivant',
  delete: 'Supprimer',
  save: 'Enregistrer',
  download: {
    open: 'Ouvrir',
    download: 'Télécharger',
    started: 'Téléchargement commencé',
    failed: 'Téléchargement échoué : {{message}}',
  },
  chat: {
    title: 'Chat',
    sendMessage: 'Envoyer le message',
    placeholder: 'Tapez un message...',
    noMessages: 'Pas encore de messages',
    loadMore: 'Charger plus de messages',
    messageSent: 'Message envoyé',
    messageError: "Impossible d'envoyer le message: {{error}}",
    newMessage: '{{name}}: nouveau message sur la commande {{orderNumber}}',
    internal: 'Interne',
    carrier: 'Transporteur',
  },
};
